import * as React from "react";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axiosConfig from "./utils/axiosConfig";
import HeaderSubPage from "./partial/HeaderSubPage";
import {ToastContainer} from "react-toastify";
import {notify} from "./utils/utils";

export default function NewsletterConfirm({partner}) {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState(null);

    const doConfirm = async () => {
        try {
            const response = await axiosConfig.get(`/newsletter/confirmation?token=${token}`);
            setStatus(response.status);
            notify(response?.data?.message, "success");
        } catch (error) {
            notify(error?.response?.data?.message || "Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.");
            setStatus(error?.response?.status);
        }
    };

    useEffect(() => {
        if (token) {
            doConfirm();
        }
    }, [token]);

    useEffect(() => {
        document.title = `${partner?.name} - Newsletter Bestätigung`;
    }, [partner]);
    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Newsletter Bestätigung'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1>
                                    Newsletter Bestätigung
                                </h1>
                                {status === 200 ? (
                                    <p>
                                        Vielen Dank für Ihre Anmeldung zu unserem Newsletter!
                                    </p>
                                ) : status ? (
                                    <p>
                                        Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.
                                    </p>
                                ) : (
                                    <p>Wird geladen...</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}